/**
 * Responsive image sources, generated from `assets-source/` by
 * `npm run optimize-images`. Spread one into <OptimizedImage /> or an <img>:
 *
 *   <OptimizedImage {...services1} sizes="(max-width: 768px) 100vw, 560px" />
 *
 * `src` is the largest variant (fallback); `srcSet` lets the browser pick.
 */
import digitalPiano1_800 from "./digitalPiano1-800.webp";
import digitalPiano1_1280 from "./digitalPiano1-1280.webp";
import grandPiano1_800 from "./grandPiano1-800.webp";
import grandPiano1_1280 from "./grandPiano1-1280.webp";
import uprightPiano1_800 from "./uprightPiano1-800.webp";
import uprightPiano1_1280 from "./uprightPiano1-1280.webp";
import pianoHistory_800 from "./pianoHistory-800.webp";
import pianoHistory_1280 from "./pianoHistory-1280.webp";
import services1_800 from "./services1-800.webp";
import services1_1280 from "./services1-1280.webp";
import services8_800 from "./services8-800.webp";
import services8_1280 from "./services8-1280.webp";
import news1_120 from "./news1-120.webp";
import news1_500 from "./news1-500.webp";
import news2_120 from "./news2-120.webp";
import news2_500 from "./news2-500.webp";
import news3_120 from "./news3-120.webp";
import news3_500 from "./news3-500.webp";
import news4_120 from "./news4-120.webp";
import news4_500 from "./news4-500.webp";
import news5_120 from "./news5-120.webp";
import news5_500 from "./news5-500.webp";
import news6_120 from "./news6-120.webp";
import news6_500 from "./news6-500.webp";

const responsive = (small, smallWidth, large, largeWidth) => ({
  src: large,
  srcSet: `${small} ${smallWidth}w, ${large} ${largeWidth}w`,
});

export const digitalPiano1 = responsive(
  digitalPiano1_800,
  800,
  digitalPiano1_1280,
  1280
);
export const grandPiano1 = responsive(
  grandPiano1_800,
  800,
  grandPiano1_1280,
  1280
);
export const uprightPiano1 = responsive(
  uprightPiano1_800,
  800,
  uprightPiano1_1280,
  1280
);
export const pianoHistory = responsive(
  pianoHistory_800,
  800,
  pianoHistory_1280,
  1280
);
export const services1 = responsive(services1_800, 800, services1_1280, 1280);
export const services8 = responsive(services8_800, 800, services8_1280, 1280);

/** Gallery photos: `thumbnail` is ~120px wide, `original` is 500px. */
export const newsPhotos = [
  { original: news1_500, thumbnail: news1_120 },
  { original: news2_500, thumbnail: news2_120 },
  { original: news3_500, thumbnail: news3_120 },
  { original: news4_500, thumbnail: news4_120 },
  { original: news5_500, thumbnail: news5_120 },
  { original: news6_500, thumbnail: news6_120 },
];
